import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  map, Observable, of,
} from 'rxjs';
import { NimmstaCommonsModuleConfiguration } from '../nimmsta-commons-module.config';
import { MaintenanceInfo } from '../models/maintenanceInfo';

@Injectable({ providedIn: 'root' })
export class MaintenanceInfoService {
  private infoCache?: MaintenanceInfo[];

  private http = inject(HttpClient);
  private configuration = inject(NimmstaCommonsModuleConfiguration);

  getMaintenanceInfo(): Observable<MaintenanceInfo[]> {
    if (this.infoCache) {
      return of(this.infoCache);
    }
    if (!this.configuration.maintenanceInfoSource) {
      return of();
    }

    return this.http.get<MaintenanceInfo[]>(this.configuration.maintenanceInfoSource).pipe(
      map((data) => {
        if (this.isValidMaintenanceFile(data)) {
          this.infoCache = data;
          return data;
        }
        return [];
      }),
    );
  }

  private isValidMaintenanceFile(maintenanceInfo: MaintenanceInfo[]): boolean {
    if (!maintenanceInfo) {
       
      console.error('Maintenance info is null or undefined');
      return false;
    }
    if (maintenanceInfo.length === 0) {
      return true;
    }
    const errors: { [key: number]: string[] } = {};
    maintenanceInfo.forEach((elem, index) => {
      const errorBuffer: string[] = [];
      if (!elem) {
        errorBuffer.push('Maintenance info element is null or undefined');
      }
      if (!elem.from || !elem.to) {
        errorBuffer.push('from or to is null or undefined');
      }
      if (elem.from && elem.to && elem.from >= elem.to) {
        errorBuffer.push('from is greater than or equal to to');
      }
      if (elem.title && (!elem.title.de || !elem.title.en)) {
        errorBuffer.push('title translations are missing');
      }
      if (!elem.text || !elem.text.de || !elem.text.en) {
        errorBuffer.push('text is null or undefined or the translations are missing');
      }
      if (!elem.type) {
        errorBuffer.push('type is null or undefined');
      }
      if (errorBuffer.length) {
        errors[index] = errorBuffer;
      }
    });
    if (Object.keys(errors).length) {
       
      console.error('Maintenance info is invalid', errors);
    }
    return Object.keys(errors).length === 0;
  }
}
